import React, { useContext } from 'react'
import { AssessmentExecutionTrackingStyles } from './Style'
import { AssessmentExecutionTrackingContext } from './AssessmentExecutionTrackingContext'
import { AffiliationsHeader, BarSummary } from '../AssessmentResultsTracking'
import { BarLineStyles } from '../Style'
import { CircularProgress } from '@mui/material'
import { useSelector } from 'react-redux'
import { thirdly6 } from 'styles/theme'
import { secondary1 } from 'styles/theme'
import BarLine from './BarLine'
import NumberAxis from '../NumberAxis'

const AssessmentExecutionTracking = () => {
    const { data: affiliations } = useContext(AssessmentExecutionTrackingContext)
    const { brokenDisplay } = useSelector(state => state.general)

    return (
        <AssessmentExecutionTrackingStyles affiliationCount={affiliations.data?.length}>
            <div className='filters-header'>
                <AffiliationsHeader description={"מוצגים נתוני ביצוע מבדקים על ידי "} Context={AssessmentExecutionTrackingContext} />
            </div>
            <BarLineStyles>
                {affiliations.data ? affiliations.data?.map((affiliation, index) =>
                    <div className='bar-item-and-label'>
                        <div>
                            <div className='space1' />
                            <div className='wrap-layout-label left-section'>
                                <div className={`layout-label ${brokenDisplay && 'blurred2'}`}>
                                    {affiliation?.name}
                                </div>
                                <i class="fa-thin fa-arrow-left-long chevron-icon"></i>
                            </div>
                        </div>
                        <div className='wrap-line-and-summary'>
                            <div className='bar-summary'>
                                <b className={`${brokenDisplay && "blurred2"}`}>{affiliation.test_taker_execution_count}</b>
                                {"מתוך"}
                                <b className={`${brokenDisplay && "blurred2"}`}>{affiliation.test_taker_count}</b>
                                <div>
                                    {" תלמידים "}
                                    <span className='bold' style={{ color: thirdly6 }}>{"סיימו "}</span>
                                    {" לבצע את סוללת המבדקים"}
                                </div>
                                {affiliation.redo_batteries_count ?
                                    <React.Fragment>
                                        {"|"}
                                        {" ב "}
                                        {affiliation.redo_batteries_count}
                                        {" סוללות נוספות יש מבדקים "}
                                        <span className='bold' style={{ color: secondary1 }}>{"לביצוע חוזר"}</span>
                                    </React.Fragment> :
                                    ""
                                }
                            </div>
                            <BarLine {...affiliation} lineIndex={index} />
                        </div>
                    </div>
                ) :
                    <div className='affiliations-loading'>
                        <CircularProgress color="thirdly" />
                    </div>
                }
            </BarLineStyles>
            <NumberAxis />
        </AssessmentExecutionTrackingStyles>
    )
}

export default AssessmentExecutionTracking